import type { ResolvedCustomField } from './types'

/**
 * Validates that all required custom fields have values.
 * Checkbox fields must be strictly `true`; all other types must be
 * non-null, non-undefined, and non-empty-string.
 */
export function validateCustomFieldValues(
  fields: ResolvedCustomField[],
  values: Record<string, unknown>
): boolean {
  for (const field of fields) {
    if (!field.required) continue
    const v = values[field.fieldName]
    if (field.inputType === 'checkbox') {
      if (v !== true) return false
    } else if (v === undefined || v === null || v === '') {
      return false
    }
  }
  return true
}
